import { render, staticRenderFns } from "./PublicCalendarListItem.vue?vue&type=template&id=97d1c29e&"
import script from "./PublicCalendarListItem.vue?vue&type=script&lang=js&"
export * from "./PublicCalendarListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d1c29e')) {
      api.createRecord('97d1c29e', component.options)
    } else {
      api.reload('97d1c29e', component.options)
    }
    module.hot.accept("./PublicCalendarListItem.vue?vue&type=template&id=97d1c29e&", function () {
      api.rerender('97d1c29e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/PublicCalendarListItem.vue"
export default component.exports